import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock, User } from "lucide-react";
import Layout from "../layout/Layout";
import SEO from "../Components/SEO/SEO";
import { blogPosts, formatBlogDate } from "../data/blogPosts";

export default function BlogPage() {
  return (
    <Layout>
      <SEO
        title="Blog | Software Development Insights | Quantum Spark Technology"
        description="Guides on choosing dev partners, React vs Next.js, discovery phases, software costs, and shipping AI features — written by the Quantum Spark Technology team."
        path="/blog"
      />

      <section className="border-b border-zinc-200 bg-[#FAFAFB] py-16 md:py-20">
        <div className="mx-auto max-w-7xl px-6">
          <p className="mb-4 text-sm font-semibold uppercase tracking-widest text-brand-purple">Insights</p>
          <h1 className="mb-6 max-w-3xl font-display text-4xl font-extrabold tracking-tight text-brand-ink md:text-5xl">
            Software development guides for founders and product teams
          </h1>
          <p className="max-w-2xl text-lg leading-relaxed text-brand-muted">
            Practical articles on planning, architecture, budgeting, and shipping — from the engineers and leaders at
            Quantum Spark Technology who build web, mobile, and AI products every day.
          </p>
        </div>
      </section>

      <section className="bg-white py-16 md:py-20">
        <div className="mx-auto max-w-7xl px-6">
          <div className="grid gap-8 md:grid-cols-2">
            {blogPosts.map((post, i) => (
              <motion.article
                key={post.slug}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className="flex flex-col rounded-3xl border border-zinc-200 bg-[#FAFAFB] p-8 transition-shadow hover:shadow-lg"
              >
                <div className="mb-4 flex flex-wrap items-center gap-3 text-sm text-brand-muted">
                  <span className="rounded-full bg-violet-50 px-3 py-1 font-medium text-brand-purple">{post.category}</span>
                  <span className="flex items-center gap-1">
                    <Clock size={14} />
                    {post.readTime}
                  </span>
                  <span>{formatBlogDate(post.date)}</span>
                </div>
                <h2 className="mb-3 font-display text-2xl font-bold text-brand-ink">
                  <Link to={`/blog/${post.slug}`} className="hover:text-brand-purple">
                    {post.title}
                  </Link>
                </h2>
                <p className="mb-6 flex-1 leading-relaxed text-brand-muted">{post.excerpt}</p>
                <div className="flex items-center justify-between border-t border-zinc-200 pt-6">
                  <div className="flex items-center gap-2 text-sm text-brand-muted">
                    <User size={16} />
                    <span>
                      {post.author}, {post.authorRole}
                    </span>
                  </div>
                  <Link
                    to={`/blog/${post.slug}`}
                    className="inline-flex items-center text-sm font-semibold text-brand-purple hover:gap-2"
                  >
                    Read article <ArrowRight size={16} className="ml-1" />
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
